import { render } from "./Carousel.vue?vue&type=template&id=48799e34"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"

import "./Carousel.vue?vue&type=style&index=0&id=48799e34&lang=css"
script.render = render

export default script